import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import { Modal } from 'react-bootstrap'
import CustomSelect from 'components/CustomSelect'

import { GET, httpOk, POST } from 'helpers/api'

import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as TileIcon } from 'assets/icons/tile.svg';
import { ReactComponent as LooseIcon } from 'assets/icons/loose.svg';
import useDidMountEffect from 'components/useDidMountEffect';

const initData = {
    "product_id": '',
    "box_type": "piece",
    "version": "",
    "created_by_id": '',
    "calc_basis": "box",
    "rows_per_box": '',
    "pieces_per_row": '',
    "components": [
        // {
        //     "raw_material_id": '',
        //     "quantity": ""
        // },
    ]
};

function CreateBox({ modal, setModal, getData, id }) {
    const { t } = useTranslation();


    const [sendData, setSendData] = useState({ ...initData });

    const [products, setProducts] = useState([])
    const [rawMaterials, setRawMaterials] = useState([])
    const [variants, setVariants] = useState([])

    async function create() {
        var sendDataCopy = { ...sendData }
        const response = await POST(`/recipes/boxes/`, sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData });
            getData();
        }
    }

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    function selectItem(option, index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.components[index].raw_material_id = option?.id;
        setSendData(sendDataCopy);
    }

    function handleChangeItem(e, index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.components[index][e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    function deleteItem(index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.components.splice(index, 1)
        setSendData(sendDataCopy);
    }

    function addToList() {
        var sendDataCopy = { ...sendData };
        sendDataCopy.components.push({
            raw_material_id: '',
            quantity: '',
        })
        setSendData(sendDataCopy);
    }

    useEffect(() => {
        async function getProducts() {
            const response = await GET('/catalogs/products/', { size: 1000 })
            if (httpOk(response)) {
                setProducts(response.data)
            }
        }

        async function getRawMaterials() {
            const response = await GET('/catalogs/raw-materials/', { size: 1000 })
            if (httpOk(response)) {
                setRawMaterials(response.data)
            }
        }


        if (modal) {
            getProducts()
            getRawMaterials()
        }
    }, [modal]);

    useDidMountEffect(() => {
        async function getVariants() {
            const response = await GET('/recipes/variants/', { size: 1000, product_id: sendData.product_id })
            if (httpOk(response)) {
                setVariants(response.data)
            }
        }


        if (sendData.product_id && sendData.recipe_type === 'tile') {
            getVariants()
        }
    }, [sendData.product_id]);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('create_box')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('describe_box')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('name')}</label>
                        <input type="text" placeholder={t('name')} name="name"
                            value={sendData.name} onChange={(e) => handleChange(e)} />
                    </div>

                    <div className="form-group">
                        <label>{t('product')}</label>
                        <CustomSelect
                            options={products}
                            value={products?.find(option => option.id === sendData?.product_id) || ''}
                            getOptionLabel={(option) => `${option.code} - ${option.name}`}
                            onChange={(option) => setSendData({ ...sendData, product_id: option.id, recipe_type: option.recipe_type })}
                            placeholder={t('select_product')}
                        />
                    </div>

                    {sendData.recipe_type === "tile" &&
                        <div className="form-group">
                            <label>{t('variant')}</label>
                            <CustomSelect
                                options={variants}
                                value={variants?.find(option => option.id === sendData?.variant_id) || ''}
                                getOptionLabel={(option) => `${option.name}`}
                                onChange={(option) => setSendData({ ...sendData, variant_id: option.id })}
                                placeholder={t('Выберите разновидность')}
                            />
                        </div>
                    }

                    <div className="card technologist">
                        <div className="fw-500">
                            {t('type')}
                        </div>

                        <div className="d-flex gap-12 w-100">
                            <div className={`technologist-tab ${sendData.box_type === 'piece' ? 'active' : ''}`} onClick={() => setSendData({ ...sendData, box_type: 'piece' })}>
                                <TileIcon />

                                <div className="technologist-tab-title">
                                    {t('bar_chocolate')}
                                </div>

                                <div className="technologist-tab-subtitle">
                                    {t('calculation_by_rows')}
                                </div>
                            </div>

                            <div className={`technologist-tab ${sendData.box_type === 'kg' ? 'active' : ''}`} onClick={() => setSendData({ ...sendData, box_type: 'kg' })}>
                                <LooseIcon />

                                <div className="technologist-tab-title">
                                    {t('weight_based')}
                                </div>

                                <div className="technologist-tab-subtitle">
                                    {t('approximate_quantity')}
                                </div>
                            </div>
                        </div>

                        {sendData.box_type === 'piece' &&
                            <div className="d-flex gap-16">
                                <div className="form-group">
                                    <label>{t('number_of_rows')}</label>
                                    <input type="text" placeholder='0' name="rows_per_box"
                                        value={sendData.rows_per_box} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className="form-group">
                                    <label>{t('pieces_per_row')}</label>
                                    <input type="text" placeholder='0' name="pieces_per_row"
                                        value={sendData.pieces_per_row} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className="form-group">
                                    <label>{t('total_in_box')}</label>
                                    <input type="text" placeholder='0' name="approx_pieces_per_box" disabled
                                        value={Number(sendData.pieces_per_row ?? 0) * Number(sendData.rows_per_box ?? 0)} />
                                </div>
                            </div>
                        }

                        {sendData.box_type === 'kg' &&
                            <div>
                                <div className="form-group mb-10">
                                    <label>{t('amount_kg')}</label>
                                    <input type="text" placeholder='0' name="amount_kg"
                                        value={sendData.amount_kg} onChange={(e) => handleChange(e)} />
                                </div>
                                <span className="text-second">
                                    {t('weight_approx_hint')}
                                </span>
                            </div>
                        }
                    </div>

                    <div className="card forth">
                        <div className="d-between mb-16">
                            <div>
                                {t('components')}
                            </div>
                            <button className="white small" onClick={() => addToList()}>
                                <PlusIcon />
                                {t('add_components')}
                            </button>
                        </div>

                        <div className="d-flex flex-column gap-12">
                            {sendData?.components?.map((item, index) => (
                                <div className="d-flex gap-8" key={index}>
                                    <div style={{ minWidth: '250px', }}>
                                        <CustomSelect
                                            options={rawMaterials}
                                            value={rawMaterials?.find(option => option.id === item?.raw_material_id) || ''}
                                            getOptionLabel={(option) => `${option.code} - ${option.name}`}
                                            onChange={(option) => selectItem(option, index)}
                                            placeholder={t('sku')}
                                        />

                                    </div>

                                    <input type="text" placeholder={t('quantity')} name="quantity" className="w-100"
                                        value={item.quantity} onChange={(e) => handleChangeItem(e, index)} />

                                    <button className="transparent small" style={{ height: '36px' }} onClick={() => deleteItem(index)}>
                                        <DeleteIcon />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('save')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default CreateBox